<!-- prettier-ignore -->

  <ion-header no-border>
    <div class="cicerone-header" [ngClass]="{'no-touch': disableTouch()}">
      
      <div class="cicerone-header__logo">
        @if(!tools.isTechEditMode()){
            @if (!tools.isRegisterMode() && !isInfoRoutePage()){
               @if((showBackButton() || isBackDistributor()) && !hideBackButtonOffline()){
                <ion-icon (click)="goBack()" name="arrow-back-outline" attr.aria-label="{{ 'Atrás' | translate }}"></ion-icon>
               }
            }
            @if(rest.device()?.logo?.value && !hideLogoOffline()){
              <img draggable="false" [src]="rest.device()?.logo?.value" (click)="goToHome()" (error)="tools.onImageError($event)" [ngClass]="{'no_click': isInfoRoutePage()}" alt="{{'Inicio' | translate}}"  />
            }
        }
        @else {
            <span>{{'Modo Edición' | translate}}</span>
        }
      </div>
  
      <div class="cicerone-header__fab">

        @if(tools.isTechEditMode()){
          <header-tech-update />
        }
  
        @if(isOnline() && !tools.isRegisterMode() && tools.isApp && !tools.isTechEditMode() && !tools.isTechMode() && !isInfoRoutePage()){
          <header-user-menu />
        }
  
        @if((!isWebApp() && (languages()?.length > 1 || showGoogleLangs())) || (isWebApp() && languages()?.length > 1)){
          <header-languages />
        }
  
        <!-- HRS-2990: la salida está en los tres modos del informador, no solo al
             crear rutas predefinidas: en registro simple y completo no había forma
             de volver a la vista del visitante desde la interfaz. -->
        @if(tools.informerMode() || tools.isTechEditMode()){
          <header-tech-logout />
        }
      </div>
  
    </div>
  </ion-header>

